

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'FollowUs',
  filters: {
    lowercase(value: string): string {
      if (!value) {
        return '';
      }
      return value.toString().toLowerCase();
    },
  },
})
export default class FollowUs extends Vue {
  @Prop([Object]) private readonly list!: {};

  public openInNewTab(url: string): void {
    window.open(url);
  }
}
